import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { getEmpresa, getEmpresas, getPessoaLogada, getRotasPermitidas, signalR } from '../actions';
import Routers from '../router';

const Components = ({
  getRotasAction,
  getPessoaAction,
  getEmpresaSelecionadaAction,
  getEmpresasAction,
  notifyRegistryAction,
}) => {
  useEffect(() => {
    getRotasAction();
    getPessoaAction().then(() => {
      getEmpresaSelecionadaAction();
      getEmpresasAction();
      notifyRegistryAction();
    });
  }, [
    getRotasAction,
    getPessoaAction,
    getEmpresaSelecionadaAction,
    getEmpresasAction,
    notifyRegistryAction,
  ]);

  return <Routers />;
};

const mapDispatchToProps = {
  getRotasAction: getRotasPermitidas,
  getPessoaAction: getPessoaLogada,
  getEmpresasAction: getEmpresas,
  getEmpresaSelecionadaAction: getEmpresa,
  notifyRegistryAction: signalR,
};

export default connect(
  null,
  mapDispatchToProps,
)(Components);
